import { Box } from "@mui/material";
import {
  AuthButton,
  SmNavlink,
  Span,
  styles,
} from "./styles";
import { useDispatch, useSelector } from "react-redux";
import { auth } from "../../../../../Infrastructure/config";
import { useLocation, useNavigate } from "react-router-dom";
import { trackEvent } from "../../../../../Infrastructure/Utilities/analytics";
import { resetUserData } from "../../../../../Infrastructure/States/userDataSlice";
import { resetSteps } from "../../../../../Infrastructure/States/educatorStepsSlice";
import useAuthentication from "../../../../../Infrastructure/States/onAuthStateChange";
import AnalyticsConstants from "../../../../../Infrastructure/Constants/AnalyticsContants";
import { resetCoursesSteps } from "../../../../../Infrastructure/States/coursesStepsSlice";
import paths from "../../../../../Infrastructure/Router/paths";
import { USER_LOGS_CLIENT } from "../../../../../Infrastructure/Constants/logsConstant";
import { safeClientLogEvent } from "../../../../../Infrastructure/Utilities/safeClientLogEvent";

export const DropdownSmallScreen = ({ handleCloseNavMenu }) => {
  const dispatch = useDispatch()
  const navigate = useNavigate();
  const location = useLocation();
  const { userId, clearAuth } = useAuthentication()
  const userData = useSelector((state) => state.userData.data);
  const handleLogout = async () => {
    auth.signOut()
    clearAuth()
    handleCloseNavMenu();
    dispatch(resetSteps());
    dispatch(resetUserData()) 
    dispatch(resetCoursesSteps());
    const eventType = userData?.is_educator ? AnalyticsConstants.EDUCATOR_LOGOUT_SUCCESS : AnalyticsConstants.LEARNER_LOGOUT_SUCCESS;
    try {
      trackEvent(eventType, {});
    } catch (trackingError) {
      await safeClientLogEvent({
        ...USER_LOGS_CLIENT.TRACKING_EVENT_FAILED,
        uid: userId || null,
        source: "dropdownSmallScreen.jsx",
        emailInfo: null,
        metadata: null,
        error: trackingError?.message || null
      });
    }
    if (
      location.pathname === paths.dashboardPage.path ||
      location.pathname === paths.accountPage.path
    ) {
      navigate(paths.home.path);
    }
  };
  const handleClose = () => {
    handleCloseNavMenu();
  };
  const handleMenuClick = (route) => {
    navigate(route);
    handleClose();
  }
  return (
    <>
      <Box width="100%">
          <Box sx={styles.root}>
            <Span>
              <SmNavlink
                onClick={() => handleMenuClick(paths.dashboardPage.path)}
                curser="pointer"
              >
                Dashboard
              </SmNavlink>
            </Span>
            <Span>
              <SmNavlink
                onClick={() => handleMenuClick(paths.accountPage.path)}
              >
                Account
              </SmNavlink>
            </Span>
          </Box>
          <Box sx={styles.logoutBox}>
            <AuthButton signup="true" onClick={handleLogout}>
              Logout
            </AuthButton>
          </Box>
        </Box>
    </>
  );
};
